import { authenticationService } from '../services/AuthService'
import { localStorageService } from '../services/localstorage-service';

export async function signIn(email, password, isChecked) {
  try {
    var response = await AuthUser(email, password, isChecked);
    if (response.employee != null) {
      return {
        isOk: true,
        data: response
      };
    }
    else {
      throw Error;
    }
  }
  catch {
    return {
      isOk: false,
      message: response
    };
  }
}

export async function getUserName() {
  try {
    // Send request
    return {
      isOk: true,
      data: localStorageService.getUserName()
    };
  }
  catch {
    return {
      isOk: false
    };
  }
}

const AuthUser = async (email, password, isChecked) => {
  try {
    if (!localStorageService.getAuthToken() || !localStorageService.getEmail() || !localStorageService.getUserName()) {
      if (isChecked === null || isChecked === undefined) {
        isChecked = false;
      }
      let response = await authenticationService.login(email, password, isChecked);
      if (response && response.employee) {
        localStorageService.setAuthToken(response.token);
        localStorageService.setUserName(response.employee.name);
        localStorageService.setStoresEmployee(JSON.stringify(response.storeEmployee));
        return response;
      }
      else {
        throw new Error(response.message);
      }
    }
    else {
      return localStorageService.getAuthToken();
    }
  }
  catch (Error) {
    return Error.message;
  }
}

export async function createAccount(email, password) {
  try {
    // Send request
    console.log(email, password);

    return {
      isOk: true
    };
  }
  catch {
    return {
      isOk: false,
      message: "Failed to create account"
    };
  }
}

export async function changePassword(email, recoveryCode) {
  try {
    // Send request
    console.log(email, recoveryCode);

    return {
      isOk: true
    };
  }
  catch {
    return {
      isOk: false,
      message: "Failed to change password"
    }
  }
}

export async function resetPassword(email) {
  try {
    // Send request
    console.log(email);

    return {
      isOk: true
    };
  }
  catch {
    return {
      isOk: false,
      message: "Failed to reset password"
    };
  }
}